// extracted by mini-css-extract-plugin
export default {"search":"styles_search__BywcK","search__wrap":"styles_search__wrap__k-Hmz","search__input":"styles_search__input__-CnY+","search__btn":"styles_search__btn__30Enq"};